export const getEnumKey = (value: number, enumObject: any): string => {
    return Object.keys(enumObject).find((key) => enumObject[key] === value) || "Unknown";
};